const tabsSections = document?.querySelectorAll('.tabs-wrapper');

tabsSections?.forEach((item) => {
  const sliderEl = item?.querySelector('.keen-slider');
  const btns = item?.querySelectorAll('.tabs button');

  let disable = false;

  if (sliderEl) {
    const slider = new KeenSlider(sliderEl, {
      slides: {
        perView: 1,
      },
      dragStarted() {
        disable = false;
      },
      slideChanged(e) {
        if (disable) return;
        const idx = e?.track?.details?.rel;

        const currentSlideOrigin = [
          ...item?.querySelectorAll('.keen-slider__slide'),
        ]?.[idx]?.dataset?.target;
        const btn = item?.querySelector(
          `.tabs button[data-origin="${currentSlideOrigin}"]`,
        );
        if (btn) {
          btns?.forEach((el) => el?.classList?.remove('active'));
          btn?.classList?.add('active');
        }
      },
    });

    btns?.forEach((btn) => {
      btn?.addEventListener('click', function (e) {
        disable = true;
        btns?.forEach((el) => el?.classList?.remove('active'));
        const originData = e?.target?.dataset?.origin;
        const slide = [
          ...item?.querySelectorAll('.keen-slider__slide'),
        ]?.findIndex((el) => el?.dataset?.target === originData);
        if (slide >= 0) {
          slider?.moveToIdx(slide);
        }
        btn?.classList?.add('active');
      });
    });
  }
});
